import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cdf23a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://t.me/burngram_support_bot",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "button button-md button-contrast"
}, " Связь с поддержкой ", -1))

import { Ref, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { OnboardSevice } from './services/OnboardService';
import { TourService } from './services/TourService';
import TheTopbar from '@/components/TheTopbar.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import BaseSimpleTour from './components/shared/BaseSimpleTour.vue';

type TextTour =
	| 'profile_edit'
	| 'balance'
	| 'create_work'
	| 'choose_work'
	| 'published'
	| 'profile'
	| 'create_by_yourself';
type TourInfo = { title: string; text: string };


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();

const showTourContents: Ref<Record<TextTour, TourInfo>> = ref({
	profile_edit: {
		title: 'Профиль',
		text: `Заполните личную информацию в профиле, чтобы получить дополнительные burn-коины на баланс.

		Это позволит вам попробовать создать свои первые работы бесплатно и увеличить баланс несложным путем ;)
		
		Можете заняться этим чуть позже, а пока - пойдем дальше.`
	},
	balance: {
		title: 'Баланс',
		text: `Это страница баланса, где вы можете пополнять свой аккаунт burn-коинами!

		На первое время за регистрацию мы вам дадим 50 burn-коинов, чтобы вы могли создать свои первые работы.`
	},
	create_work: {
		title: 'Создание работы',
		text: `Отлично! На ваш баланс пришли первые burn-коины, и вы можете создать первую работу.

		Это работает очень просто - нажмите на кнопку и нейросеть сгенерирует картинки на тему часа.`
	},
	choose_work: {
		title: 'Выбор работы',
		text: `Здесь необходимо выбрать одну из работ, которая создала нейросеть.
		Достаточно только нажать на нее и нажать “Опубликовать” :)

		Если вам не понравилась ни одна из работ, используйте новую попытку.`
	},
	published: {
		title: 'Работа опубликована',
		text: `Вы видите свою работу в ленте.

		Количество лайков и реакций возможно увидеть после того, как закончится актуальная тема часа.`
	},
	profile: {
		title: 'Профиль',
		text: `Это ваша страница. На ней видны опубликованные и выкупленные платформой работы, также как и полученные вами ачивки :)

		Поменять аватарку и никнейм вы можете нажав на кнопку "Изменить".

		А ещё можете поделиться профилем в соц. сетях нажав на кнопку "Поделиться".`
	},
	create_by_yourself: {
		title: 'Создать',
		text: `Пришло время попробовать пройти весь путь самостоятельно, но мы всегда на связи!`
	}
});

const tourActions: Record<number, (first: boolean) => void> = {
	// Edit profile for burns
	1: () => {
		console.log('Activated tour step 1: profile_edit');

		router.push('/profile/edit');
		showTour.value = 'profile_edit';
	},
	// Balance with burns
	2: () => {
		console.log('Activated tour step 2: balance');

		router.push('/balance');
		showTour.value = 'balance';
	},
	// Create work
	3: () => {
		console.log('Activated tour step 3: create_work');

		router.push('/create');
		showTour.value = 'create_work';
	},
	// Choose generated work
	4: (first: boolean) => {
		if (first) {
			TourService.changeStep(3);
		}

		console.log('Activated tour step 4: choose_work');
		showTour.value = 'choose_work';
	},
	// Published
	5: () => {
		console.log('Activated tour step 5: published');

		router.push('/');
		showTour.value = 'published';
	},
	// Profile
	6: () => {
		console.log('Activated tour step 6: profile');

		router.push('/profile');
		showTour.value = 'profile';
	},
	// Try by yourself
	7: () => {
		console.log('Activated tour step 7: create_by_yourself');

		router.push('/create');
		showTour.value = 'create_by_yourself';
	}
};

const locked: Ref<boolean> = ref(false);
const showTour: Ref<null | TextTour> = ref(null);
onBeforeMount(() => {
	const { onboardTourState } = OnboardSevice;

	// Lock UI if not finished
	if (onboardTourState?.finished === false) {
		if (onboardTourState.step >= 8) {
			finishStep();
			return;
		}

		locked.value = true;
		stepVisible.value = true;

		// This step only works in realtime
		if (onboardTourState.step === 4) {
			onboardTourState.step = 3;
		}

		// Initial
		console.log('Initial step:', onboardTourState.step ?? 0);
		tourActions[onboardTourState.step ?? 0]?.(true);

		// When changed
		TourService.addStepListener((step: number, finished: boolean) => {
			if (step >= 8) {
				finishStep();
				return;
			}

			console.log('Changing step:', step);
			stepVisible.value = true;

			// Finish tour
			if (finished) {
				locked.value = false;
				router.push('/');
			}

			tourActions[step]?.(false);
		});
	}
});

const stepVisible: Ref<boolean> = ref(false);
function nextStep() {
	const { onboardTourState } = OnboardSevice;
	if (!onboardTourState) return;

	// Step is increased by view
	if (onboardTourState.step === 3 || onboardTourState.step === 4) {
		stepVisible.value = false;
		return;
	}

	TourService.changeStep(onboardTourState.step + 1);
}

function finishStep() {
	locked.value = false;
	stepVisible.value = false;
	OnboardSevice.onboardTourState = {
		step: 8,
		finished: true
	};
}

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (locked.value && showTour.value !== null && stepVisible.value)
      ? (_openBlock(), _createBlock(BaseSimpleTour, {
          key: 0,
          onClose: nextStep,
          title: showTourContents.value[showTour.value].title,
          text: showTourContents.value[showTour.value].text,
          "button-text": 
				showTour.value === 'create_by_yourself' ? 'Завершить' : 'Далее'
			
        }, _createSlots({ _: 2 }, [
          (showTour.value === 'create_by_yourself')
            ? {
                name: "before-button",
                fn: _withCtx(() => [
                  _hoisted_2
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title", "text", "button-text"]))
      : _createCommentVNode("", true),
    (_ctx.$route.meta?.isMain)
      ? (_openBlock(), _createBlock(TheTopbar, {
          key: 1,
          "data-locked": locked.value
        }, null, 8, ["data-locked"]))
      : _createCommentVNode("", true),
    _createVNode(_component_RouterView),
    (_ctx.$route.meta?.isMain)
      ? (_openBlock(), _createBlock(TheNavbar, {
          key: 2,
          "is-light": _ctx.$route.meta?.isLight === true,
          "data-locked": locked.value
        }, null, 8, ["is-light", "data-locked"]))
      : _createCommentVNode("", true)
  ]))
}
}

})